import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import imagenesEditProject from "../assets/imgEditProject/imgEditProject";
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

function InternshipsInformation() {
    const { id } = useParams();
    const MySwal = withReactContent(Swal);
    const navigate = useNavigate();
    const cookies = new Cookies();
    const getSesion = cookies.get("Bearer");
    const [isLoading, setIsLoading] = useState(true);

    const initialInternship = {
        application_deadline: "",
        created_at: "",
        description: "",
        end_date: "",
        id: 0,
        id_company: 0,
        id_type_internship: 0,
        id_type_opportunities: 0,
        id_work_modality: 0,
        job_title: "",
        location: "",
        remuneration: "",
        schedules: "",
        start_date: "",
        status: 0,
        updated_at: ""
    };

    const [internship, setInternship] = useState(initialInternship);

    const workModalities = ["", "Presencial", "Remoto", "Híbrido"];
    const internshipTypes = ["", "Remunerada", "No remunerada"];

    const getWorkModality = (id) => workModalities[id] || "No especificado";
    const getInternshipType = (id) => internshipTypes[id] || "No especificado";

    const applyInternship = () => {
        MySwal.fire({
            title: "¿Está seguro?",
            text: "Sí, deseo enviar mi perfil para esta pasantía",
            color: "#fff",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Enviar",
            cancelButtonText: "Cancelar",
            background: '#1a365d'
        }).then((result) => {
            if (result.isConfirmed) sendApplication();
        });
    };

    const sendApplication = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URI}freelancer/apply-project/${getSesion.id}`;
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json',
                    'ApiToken': `Bearer ${getSesion.token}`
                }
            };

            const applicationData = {
                budget: "",
                id_type_opportunities: 1,
                project_id: id,
                project_proposal: "",
            };

            await axios.post(url, applicationData, config);

            MySwal.fire({
                title: "¡Completado!",
                text: "Tu perfil ha sido enviado con éxito! En los próximos días recibirás una notificación sobre el proceso a través de tu correo electrónico.",
                color: "#fff",
                icon: "success",
                background: '#1a365d'
            });

            setTimeout(() => navigate('/perfil-freelancer'), 3000);
        } catch (err) {
            MySwal.fire({
                position: 'center',
                icon: 'warning',
                title: err.response?.data?.message || 'Error al enviar la solicitud',
                showConfirmButton: false,
                timer: 3500,
                background: '#1a365d'
            });
        }
    };

    const fetchInternship = async () => {
        setIsLoading(true);
        try {
            const url = `${process.env.REACT_APP_API_URI}project/get/${id}?id_type_opportunities=1`;
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'ApiToken': `Bearer ${getSesion.token}`
                }
            };

            const response = await axios.get(url, config);
            setInternship(response.data);
        } catch (err) {
            console.error(err);
            MySwal.fire({
                title: 'Error',
                text: 'No se pudo cargar la información de la pasantía',
                icon: 'error',
                background: '#1a365d'
            });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchInternship();
    }, [id]);

    if (isLoading) {
        return (
            <div className="min-h-screen bg-turquoise flex items-center justify-center">
                <div className="text-white text-2xl">Cargando...</div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-b from-Light-purple via-turquoise to-Dark-purple py-8 px-4 sm:px-6 lg:px-8">
            <div className="max-w-6xl mx-auto">
                {/* Header with back button */}
                <div className="flex items-center mb-8">
                    <button
                        onClick={() => navigate(-1)}
                        className="mr-4 p-2 rounded-full hover:bg-blue-700 transition-colors"
                    >
                        <img
                            src={imagenesEditProject.arrow_back_4}
                            className="w-8 h-8"
                            alt="Volver"
                        />
                    </button>
                    <h1 className="text-Yellow text-3xl font-bold">Pasantía</h1>
                </div>

                {/* Internship title */}
                <h1 className="text-white text-2xl sm:text-3xl md:text-4xl font-bold mb-6">
                    {internship.job_title}
                </h1>

                {/* Internship description */}
                <div className="bg-blue-900 bg-opacity-30 rounded-lg p-6 mb-8">
                    <p className="text-white text-lg leading-relaxed">
                        {internship.description}
                    </p>
                </div>

                {/* Internship details grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
                    {/* Left column */}
                    <div className="space-y-6">
                        <div className="bg-blue-900 bg-opacity-30 rounded-lg p-6">
                            <h2 className="text-Yellow text-xl font-semibold mb-4">Detalles de la pasantía</h2>

                            <div className="space-y-4">
                                <div>
                                    <h3 className="text-Yellow text-lg">Tipo de pasantía</h3>
                                    <p className="text-white">
                                        {getInternshipType(internship.id_type_internship)}
                                    </p>
                                </div>

                                {internship.id_type_internship === 1 && (
                                    <div>
                                        <h3 className="text-Yellow text-lg">Remuneración</h3>
                                        <p className="text-white">
                                            ${internship.remuneration || 'No especificada'}
                                        </p>
                                    </div>
                                )}

                                <div>
                                    <h3 className="text-Yellow text-lg">Modalidad</h3>
                                    <p className="text-white">
                                        {getWorkModality(internship.id_work_modality)}
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-Yellow text-lg">Fecha límite de aplicación</h3>
                                    <p className="text-white">
                                        {internship.application_deadline}
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* Right column */}
                    <div className="space-y-6">
                        <div className="bg-blue-900 bg-opacity-30 rounded-lg p-6">
                            <h2 className="text-Yellow text-xl font-semibold mb-4">Información adicional</h2>

                            <div className="space-y-4">

                                <div>
                                    <h3 className="text-Yellow text-lg">Fecha de inicio</h3>
                                    <p className="text-white">
                                        {internship.start_date}
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-Yellow text-lg">Fecha de finalización</h3>
                                    <p className="text-white">{internship.end_date}</p>
                                </div>

                                <div>
                                    <h3 className="text-Yellow text-lg">Ubicación</h3>
                                    <p className="text-white">
                                        {internship.location || 'No especificada'}
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-Yellow text-lg">Horario de trabajo</h3>
                                    <p className="text-white">
                                        {internship.schedules || 'No especificado'}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Apply button */}
                <div className="text-center">
                    <button
                        onClick={applyInternship}
                        className="bg-Yellow hover:bg-yellow-600 text-white font-bold py-3 px-8 rounded-lg text-lg transition-colors duration-300"
                    >
                        Enviar mi perfil
                    </button>
                </div>
            </div>
        </div>
    );
}

export default InternshipsInformation;